import React, { useEffect, useState } from 'react';
import { Popconfirm, Button, Card, Space, Table, Input } from 'antd';
import moment from 'moment-jalaali';
import EditBlogPost from './EditBlogPost';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import BlogService from '../../services/BlogService';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { useNonePersistedStore } from '../../store/non-persisted-store';

export default function BlogPosts() {
    const general = useGeneralStore();
    const { GET_POSTS_SUCCESS, BLOG_LOADING, GET_POST_SUCCESS, JOB_POSTS_SUCCESS, posts: postState } = useNonePersistedStore()
    const { NotifSuccess } = general
    const { business } = usePersistedStore();
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const [editMode, setEditMode] = useState({
        isEditing: false,
        value: 0,
        id: 0
    });

    const [orderbyChanged, setOrderbyChanged] = useState({
        edited: false,
    });
    const loading = postState.loading
    const posts = postState.data;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;
    // let sortedPosts = posts && posts.sort((a, b) => (a.orderbyId < b.orderbyId) ? 1 : -1 && (a.orderbyId === b.orderbyId) && (a.publishDate < b.publishDate) ? 1 : -1)
    let sortedPosts = posts

   useEffect(() => {
        if (token)
            getPosts();
    }, [token]);

    async function getPosts() {
        BLOG_LOADING(true)
        await BlogService.getPostsService(token).then(res => {
            GET_POSTS_SUCCESS(res.data)
            BLOG_LOADING(false)
        }).catch(error => {
            BLOG_LOADING(false)

        })
    }
    function deletePost(id) {
        BLOG_LOADING(true)
        BlogService.deletePostsService(id, token).then(res => {
            BLOG_LOADING(false)
            NotifSuccess('پست با موفقیت حذف شد')
            getPosts()
        }).catch(error => {
            BLOG_LOADING(false)

        })
    }
    function postJob() {
        BLOG_LOADING(true)
        BlogService.postJobService(token).then(res => {
            BLOG_LOADING(false)
            JOB_POSTS_SUCCESS(res.data.data)
            getPosts()
        }).catch(error => {
            BLOG_LOADING(false)

        })
    }

    function categoryJob() {
        BLOG_LOADING(true)
        BlogService.categoryJobService(token).then(res => {
            BLOG_LOADING(false)
        }).catch(() => {
            BLOG_LOADING(false)

        })
    }

    function getPost(postId) {
        BLOG_LOADING(true)
        BlogService.getPostService(postId, token).then(res => {
            BLOG_LOADING(false)
            GET_POST_SUCCESS(res.data)

        }).catch(() => {
            BLOG_LOADING(false)

        })
    }

    let searchInput;

    const getColumnSearchProps = (dataIndex, title) => ({

        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={(node) => {
                        searchInput = node;
                    }}
                    placeholder={`جستجو ${title}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottohm: 8, display: "block" }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}>جستجو</Button>
                    <Button
                        onClick={() => handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}> پاک کردن</Button>
                </Space>
            </div>
        ),

        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ""}
                />
            ) : (text)
    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText("");
    };
    const handleEditMode = (record) => {
        setEditMode({ isEditing: true, value: record.orderbyId, id: record.id });
    }

    const columns = [
        {
            title: "عنوان",
            dataIndex: "title",
            key: "title",
            ...getColumnSearchProps("title", "عنوان"),
            render: (text, record) => <span className={record.enable ? "" : "disablePost-title"}>{text}</span>
        },
        {
            title: "دسته بندی",
            dataIndex: "categoryName",
            key: "categoryName",
            ...getColumnSearchProps("categoryName", "دسته بندی"),
        },
        {
            title: "تاریخ نشر",
            dataIndex: "publishDate",
            key: "publishDate",
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.publishDate ? first = a.publishDate : first = '';
                b.publishDate ? second = b.publishDate : second = '';
                return first.localeCompare(second)
            },
            render: (item) => <span>{moment(item).format('jYYYY/jMM/jDD')}</span>,
        },
        {
            title: "مرتب سازی",
            dataIndex: "orderbyId",
            key: "orderbyId",
            sorter: (a, b) => a.orderbyId - b.orderbyId,
            render: (item, record) => <div>
                <label>
                    {item}
                </label>
                {/*
                    // editMode.id === record.id && editMode.isEditing ?
                    // <input id="orderby" className="edit-orderby" defaultValue={editMode.value}
                         onChange={(e) => handleChangeOrderby(e, record)} /> :
                     <label onClick={() => handleEditMode(record)}
                    // >{editMode.id === record.id && orderbyChanged.edited ? editMode.value : item}</label>
                    */}
            </div>
        },
        {
            title: "",
            dataIndex: "operation",
            key: "operation",
            render: (_, record) =>
                sortedPosts.length >= 1 && (
                    <Space size="large">
                        <Popconfirm
                            title="آیا از حذف پست مطمئن هستید؟"
                            onConfirm={() => deletePost(record.id)}
                        >
                            <button type="danger" className="btn btn-danger btn-sm waves-effect waves-light" style={{ display: "flex" }}>
                                <i className="fas fa-minus font-size-14 align-middle mr-2"></i> حذف
                            </button>
                        </Popconfirm>
                        <button type="dashed" className="btn btn-warning btn-sm waves-effect waves-light" style={{ display: "flex" }}
                            onClick={() => {
                                general.TogglePostEditModal();
                                getPost(record.id)
                            }}>
                            <i className="far fa-edit font-size-14 align-middle mr-2"></i> ویرایش
                        </button>
                        <button type="dashed" className="btn btn-primary btn-sm waves-effect waves-light">
                            <a href={record.link} target='_blank' rel="noopener noreferrer" style={{ textDecoration: "none", display: "flex", color: "#fff" }}>
                                <i className="fas fa-external-link-alt font-size-14 align-middle mr-2"></i>لینک</a>
                        </button>
                    </Space>
                )
        }
    ]

    return (
        <Card>
            <div style={{ float: "left", marginBottom: "20px", fontSize: "14px" }}>
                <button disabled={loading} type="primary" className="btn btn-info waves-effect waves-light" style={{ marginLeft: '10px' }} onClick={() => postJob()}>
                    <i className="far fa-play-circle font-size-14 align-middle mr-2"></i>اجرای جاب پست ها</button>
                <button disabled={loading} type="primary" className="btn btn-info waves-effect waves-light" onClick={() => categoryJob()}>
                    <i className="far fa-play-circle font-size-14 align-middle mr-2"></i>اجرای جاب دسته بندی ها</button>
            </div>
            <Table
                className="custom-table"
                bordered
                columns={columns}
                loading={loading}
                rowKey="id"
                dataSource={sortedPosts}
                scroll={true}
            />
            <EditBlogPost />
        </Card>
    )
}